function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10Z",
  fill: "#933EC5"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.8444 9.29875C15.739 9.18021 13.2201 6.3999 10.0001 6.3999C6.77988 6.3999 4.26108 9.18021 4.15544 9.29886C3.94817 9.53128 3.94817 9.86852 4.15556 10.1012C4.26108 10.2197 6.77988 12.9999 10.0001 12.9999C13.2201 12.9999 15.739 10.2195 15.8446 10.1009C16.0518 9.86852 16.0518 9.53128 15.8444 9.29875ZM10.9836 8.07006C11.2001 7.95733 11.5021 8.08668 11.6579 8.35884C11.8138 8.63112 11.7646 8.94326 11.548 9.05598C11.3316 9.16882 11.0295 9.03936 10.8736 8.7672C10.7178 8.49492 10.767 8.18278 10.9836 8.07006ZM5.20255 9.6999C5.85775 10.3451 7.75072 11.9926 10.0001 11.9926C12.2494 11.9926 14.1423 10.3454 14.7975 9.6999C14.3551 9.26411 13.3479 8.37186 12.0478 7.83811C12.3014 8.20602 12.4499 8.64564 12.4499 9.11885C12.4499 10.4092 11.353 11.4552 9.99998 11.4552C8.64694 11.4552 7.55015 10.4092 7.55015 9.11885C7.55015 8.64564 7.69881 8.20602 7.95238 7.83811C6.65234 8.37174 5.645 9.26411 5.20255 9.6999Z",
  fill: "white"
});

var SvgEyeIcon = function SvgEyeIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEyeIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/eye-icon.d52073b4.svg";
export { ForwardRef as ReactComponent };